import { render, staticRenderFns } from "./QuotesGroup.vue?vue&type=template&id=d714e8be&scoped=true"
import script from "./QuotesGroup.vue?vue&type=script&lang=js"
export * from "./QuotesGroup.vue?vue&type=script&lang=js"
import style0 from "./QuotesGroup.vue?vue&type=style&index=0&id=d714e8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d714e8be",
  null
  
)

export default component.exports